import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToastService } from '../../services/toast.service';

@Component({
  selector: 'app-global-toast',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div
      *ngIf="toastService.currentToast() as toast"
      class="toast"
      [ngClass]="[toast.color, 'show']"
      [attr.data-toast-id]="toast.id"
    >
      {{ toast.message }}
    </div>
  `,
  styleUrls: ['./global-toast.component.scss'],
})
export class GlobalToastComponent implements OnInit, OnDestroy {
  protected readonly toastService = inject(ToastService);

  ngOnInit(): void {
    // Component is ready to display toasts
  }

  ngOnDestroy(): void {
    // Clear any pending timeouts when component is destroyed
    this.toastService.clearTimeouts();
  }
}
